<template>
  <div class="foot">
    <div class="foot-top" v-if="footTopShow">
      <ul class="menu-lists">
        <li v-for="item in footMenus" :key="item.index">
          <p>{{ item.title }}</p>
          <ul>
            <li v-for="itemcontent in item.lists" :key="itemcontent.index" >
              <a href="#">{{ itemcontent.content }}</a>
            </li>
          </ul>
        </li>
      </ul>
      <div class="erwei-num">
        <template v:if="weChatImg">
          <!-- <img  class="footer-logo" src="~assets/img/white_logo1.png" alt="金米云（深圳）技术有限公司"> -->
          <img  class="footer-erweima" v-bind:src="weChatImg" alt="金米云（深圳）技术有限公司">
          <span>{{weChatInfo}}</span>
        </template>
      </div>
    </div>
    <div class="foot-bottom">
      <div class="copyright">
        <p>
          <span>© {{beiancomname}}</span>
          <a v-bind:href="beianlink"  target="_blank">{{beianinfo}}</a>版权所有
        </p>
      </div>
      <div class="iso">
        <!-- <img src="~assets/img/bottom-telephone.png" alt="金米云（深圳）技术有限公司"> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabBar',
  data () {
    return {
      footMenus: [
        {
          index: 1,
          title: '首页',
          lists: [
            { index: 1, content: '公司简介' },
            // { index: 2, content: '企业营销解决方案' },
            // { index: 3, content: '电商平台解决方案' },
            // { index: 4, content: '旅游平台解决方案' },
            // { index: 5, content: '视频流解决方案' }
          ]
        },
        // {
        //   index: 2,
        //   title: '解决方案',
        //   lists: [
        //     { index: 1, content: '企业营销解决方案' },
        //     { index: 2, content: '电商平台解决方案' },
        //     { index: 3, content: '旅游平台解决方案' },
        //     { index: 4, content: '视频流解决方案' }
        //   ]
        // },
        // {
        //   index: 3,
        //   title: '互联网资讯中心',
        //   lists: [
        //     { index: 1, content: '企业营销解决方案' },
        //     { index: 2, content: '电商平台解决方案' },
        //     { index: 3, content: '旅游平台解决方案' },
        //     { index: 4, content: '视频流解决方案' }
        //   ]
        // },
        {
          index: 2,
          title: '关于我们',
          lists: [
            { index: 1, content: '公司介绍' },
            // { index: 2, content: '发展历程' },
            { index: 3, content: '联系我们' },
            // { index: 4, content: '加入我们' }
          ]
        }
      ],
      // weChatImg:"https://www.dhfapp.com/wp-content/themes/dhfeng/images/lsx.png",
      // weChatInfo:"联系说明",
      // beiancomname:"金米云（深圳）技术有限公司",
      // beianinfo:"粤ICP备2020112255号",
      // footTopShow:false,
      // beianlink:"http://beian.miit.gov.cn/"
    }
  },
  created () {
    // ...
    if(this.configData){
      this.weChatImg=this.configData.weChatImg
      this.footTopShow=this.configData.footTopShow;
      this.beiancomname=this.configData.comName;
      this.beianinfo=this.configData.beianInfo
      this.beianlink=this.configData.beianlink;
    }
  }
  // mounted () {
  //   console.log(this.footMenus)
  //   for (const i in this.footMenus) {
  //     console.log(this.footMenus[i])
  //   }
  // }
}

</script>
<style lang="scss" scoped>
.foot {
  width: 90%;
  padding: 0 5%;
  padding-top: 100px;
}
.foot-top {
  display: flex;
  justify-content: space-between;
  >ul {
    display: flex;
    max-width: 600px;
    min-width: 100px;
    justify-content: space-between;
    text-align: left;
    >li {
      font-size: 12px;
      color: #797a85;
      padding:0 10px;
      p {
        display: block;
        margin-bottom: 20px;
        cursor: pointer;
        color: #c6c6d1;
      }
      li {
        margin: 10px 0;
        a {
          font-size: 12px;
          color: #797a85;
        }
      }
    }
  }
  .erwei-num {
    display: flex;
    flex-direction: column;
    .footer-logo {
      width: 120px;
      height: 22px;
      margin-bottom: 20px;
    }
    .footer-erweima {
      width: 120px;
      height: 120px;
    }
    span {
      font-size: 12px;
      display: block;
      margin: 10px 0;
      text-align: center;
    }
  }
}
.foot-bottom {
  display: flex;
  padding-top: 20px;
  border-top: 1px solid #454f62;
  justify-content: center;
  .copyright {
    p {
      font-size: 12px;
      margin-bottom: 5px;
      span {
        margin-right: 10px;
      }
    }
  }
}
</style>
